import React from 'react';

function PadSplit(props) {
    const colour = props.fill || '#F5A623';
    const className = props.className;
    const width = props.width || 40;
    const height = props.height || 40;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 300 300"
            fill="none"
            className={className}
        >
            <circle cx="150" cy="150" r="132" fill="none" stroke={colour} strokeWidth="7"/>
            <g transform="translate(150 150) rotate(32) translate(-30 -34)" fill={colour}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M -70,0 a 18,18 0 1,0 36,0 a 18,18 0 1,0 -36,0 Z M -52,-11 L -49.17,-2.83 L -41,0 L -49.17,2.83 L -52,11 L -54.83,2.83 L -63,0 L -54.83,-2.83 Z"
                />
                <rect x="-40" y="-4.5" width="86" height="9" rx="3"/>
                <rect x="28" y="3" width="8" height="13" rx="2"/>
                <rect x="42" y="3" width="8" height="20" rx="2"/>
            </g>
            <g transform="translate(150 150) rotate(32) translate(2 34)" fill={colour}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M -70,0 a 18,18 0 1,0 36,0 a 18,18 0 1,0 -36,0 Z M -52,-11 L -49.17,-2.83 L -41,0 L -49.17,2.83 L -52,11 L -54.83,2.83 L -63,0 L -54.83,-2.83 Z"
                />
                <rect x="-40" y="-4.5" width="86" height="9" rx="3"/>
                <rect x="28" y="3" width="8" height="13" rx="2"/>
                <rect x="42" y="3" width="8" height="20" rx="2"/>
            </g>
        </svg>
    );
}

export default PadSplit;
